import Box from '@mui/material/Box'
import { styled, css } from '@mui/system'
import Typography from '../../atoms/typography'

export const ImageWrapper = styled('div')`
	width: 100%;
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	width: calc(100vw - var(--scrollBarWidth));
	transform: translateX(-50%);
	margin-left: 50% !important;
	margin: 0;
	--scrollBarWidth: 0px;
	min-height: 300px;
	${({ theme }) => theme.breakpoints.up('md')} {
		--scrollBarWidth: var(--global-scrollbar-width, 0px);
	}
`

export const Overlay = styled('div')`
	position: absolute;
	margin: auto;
	z-index: 2;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	text-align: center;
	align-items: center;
`

export const Name = styled(Typography)``

export const Count = styled(Typography)`
	font-size: ${({ theme }) => theme.typography.pxToRem(14)};
	margin-left: ${({ theme }) => theme.spacing(1)};
	${({ theme }) => theme.breakpoints.up('md')} {
		margin-left: ${({ theme }) => theme.spacing(2)};
		font-size: ${({ theme }) => theme.typography.pxToRem(20)};
	}
`

const commonStyles = ({ theme }) => css`
	width: 100%;
	display: flex;
	gap: 24px;
	margin-top: 0;
	${theme.scrollbar};
	overflow-scrolling: touch;
	overflow-x: auto;
	.MuiLink-root {
		align-items: center;
		color: ${theme.palette.primary.main};
		display: flex;
		white-space: nowrap;
		position: relative;
		min-height: 38px;
		letter-spacing: var(--letter-spacing);
		font-size: var(--font-size-body1);
		&::after {
			width: 0%;
			position: absolute;
			content: '';
			height: 1px;
			background: var(--color-primary);
			bottom: 0;
		}

		&.active {
			&::after {
				width: 100%;
			}
		}
	}
`

export const ChildrenCategories = styled(Box)`
	${(props) => commonStyles(props)};
	border-bottom: 1px solid var(--color-grey50);
	padding-bottom: var(--spacing-1);
	padding-right: var(--spacing-3);
	.MuiLink-root {
		align-items: center;
		text-transform: lowercase;
		&.active,
		&:hover {
			border-color: ${({ theme }) => theme.palette.primary.main};
		}
	}

	&:after {
		display: block;
		content: '';
		background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);
		height: 100%;
		width: 40px;
		position: absolute;
		bottom: 0;
		right: 0;
	}

	${({ theme }) => theme.breakpoints.up('md')} {
		border-bottom: none;
	}
`

export const SiblingsCategories = styled(Box)`
	${(props) => commonStyles(props)};
	border-bottom: 1px solid var(--color-grey50);
	padding-bottom: var(--spacing-1);
	padding-right: var(--spacing-3);
	.MuiLink-root {
		align-items: center;
		text-transform: lowercase;
		&.active,
		&:hover {
			border-color: ${({ theme }) => theme.palette.primary.main};
		}
	}

	&:after {
		display: block;
		content: '';
		background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);
		height: 100%;
		width: 40px;
		position: absolute;
		bottom: 0;
		right: 0;
	}

	${({ theme }) => theme.breakpoints.up('md')} {
		border-bottom: none;
	}
`

export const TitleWrapper = styled('div')`
	display: flex;
	flex: 1 0 50%;
	flex-wrap: wrap;
	align-items: flex-start;
	max-width: 100%;
	flex-direction: column;
	margin-top: ${({ theme }) => theme.spacing(4)};
	padding-left: ${({ theme }) => theme.spacing(1)};
	padding-right: ${({ theme }) => theme.spacing(1)};

	${({ theme }) => theme.breakpoints.up('md')} {
		margin-bottom: 0;
		margin-top: ${({ theme }) => theme.spacing(6)};
		padding-left: ${({ theme }) => theme.spacing(2)};
		padding-right: ${({ theme }) => theme.spacing(2)};
	}
`
